import type { Exam, ExamState } from '../../exam.js';
import { confirmExamCreation } from '../exam-creation/confirm-exam-creation.js';
import { isExamCreatorLocked } from '../../utils/exam-lock.js';

export const confirmExamCreationToolDef = [
  {
    type: 'function',
    function: {
      name: 'confirm_exam_creation',
      description:
        'Bestätigt die mit create_exam erstellte Klausur endgültig (finale Bestätigung). Erst danach sind der PDF-Download und das Online-Ausfüllen/die Online-Abgabe möglich — vorher sind beide gesperrt, damit die Struktur der Klausur zur internen Struktur passt. Die Bestätigung sperrt außerdem den Klausur-Editor (read-only) und jede weitere Änderung per KI; sie kann nicht rückgängig gemacht werden.\n\n' +
        'Rufe dieses Tool NUR auf, wenn der User ausdrücklich verlangt, die Klausur zu bestätigen bzw. abzuschließen ("bestätige die Klausur", "die Klausur ist fertig", "ich will sie jetzt herunterladen/online ausfüllen" nach deiner Rückfrage). Rufe es NIEMALS von dir aus auf. Wenn der User nur den Download oder das Online-Ausfüllen verlangt und die Klausur noch nicht bestätigt ist, erkläre ihm, dass zuerst die finale Bestätigung nötig ist und dass danach keine Änderungen mehr möglich sind, und frage, ob du bestätigen sollst. Alternativ kann er den Button "Klausur bestätigen" im Klausur-Editor nutzen.',
      parameters: {
        type: 'object',
        properties: {
          confirmed: {
            type: 'boolean',
            description: 'true, wenn der User die finale Bestätigung der Klausur ausdrücklich verlangt hat',
          },
        },
        required: ['confirmed'],
      },
    },
  },
];

export async function handleConfirmExamCreation(exam: Exam, toolCallArgs: any): Promise<object> {
  if (!toolCallArgs?.confirmed) {
    return { content: 'SYSTEM INFO: Die Klausur wurde nicht bestätigt. Es wurde nichts geändert.' };
  }

  const result = await confirmExamCreation(exam._id);
  if (!result.ok) {
    return {
      content:
        result.reason === 'generating'
          ? 'SYSTEM INFO: Die Klausur wird gerade noch erstellt oder angepasst und kann deshalb noch nicht bestätigt werden. Bitte den User, zu warten, bis sie fertig ist.'
          : 'SYSTEM INFO: Es gibt noch keine fertig erstellte Klausur, die bestätigt werden könnte (z.B. weil sie hochgeladen statt mit create_exam erstellt wurde). Erkläre das dem User.',
    };
  }
  if (result.alreadyConfirmed) {
    return {
      content:
        'SYSTEM INFO: Die Klausur war bereits bestätigt. PDF-Download und Online-Abgabe sind verfügbar; der Klausur-Editor ist schreibgeschützt.',
    };
  }
  return {
    content:
      'SYSTEM INFO: Die Klausur wurde bestätigt. Der Klausur-Editor ist jetzt schreibgeschützt, und der PDF-Download sowie das Online-Ausfüllen/die Online-Abgabe sind ab jetzt verfügbar. Teile das dem User mit.',
  };
}

/**
 * Offered only for an exam that `create_exam` produced (it has typst source) and that is not yet locked —
 * once confirmed (or locked by downstream work) there is nothing left to confirm. Defaults to offered when
 * there is no exam, same convention as the other exam-dependent tools.
 */
export function confirmExamCreationAvailability(_examState: ExamState, exam?: Exam): boolean {
  if (!exam) return true;
  if (!(exam as any).examSource) return false;
  return !isExamCreatorLocked(exam);
}
